$(document).ready(function() {
    addAltText();

    // last pass fix for warranty registration page
    /*var checkExist = setInterval(function() {
        console.log(123)
    if($('.needsclick ~ data-lastpass-icon-root').length > 0) {
        console.log(5)
        $('data-lastpass-icon-root').attr('style','position: absolute !important; bottom: 0 !important; height: 0px !important; width: 0px !important; float: left !important');
        clearInterval(checkExist);
    }

    }, 100);*/

    $('.btn-announcement').on('click', function() {
        $('newsletter-popup').attr('style','opacity: 1; transform: translateY(0px); display: block;');
    });

    $('.pop-in__close-button').on('click', function() {
        $('newsletter-popup').attr('style','opacity: 0; transform: translateY(25px); display: none;');
    });
});

function addAltText() {
    String.prototype.filename=function(extension){
        var s= this.replace(/\\/g, '/');
        s= s.substring(s.lastIndexOf('/')+ 1);
        return extension? s.replace(/[?#].+$/, ''): s.split('.')[0];
    }

    $('img').each(function() {
        if( this.alt == "" ) {
            var filename = $(this).attr('src').filename();
            $(this).attr('alt',filename);
        }
    });
}